import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { GraduationCap, CreditCard, LogOut } from 'lucide-react';

const PortalSelection = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-4">
            <div className="max-w-4xl w-full">
                <div className="text-center mb-12">
                    <h1 className="text-3xl font-bold text-slate-900 mb-4">Bienvenido, {user?.displayName}</h1>
                    <p className="text-slate-600">Seleccione el portal al que desea acceder</p>
                </div>

                <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto">
                    {/* Campus Card */}
                    <button 
                        onClick={() => navigate('/campus')}
                        className="group bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-slate-100 hover:border-blue-500 text-left"
                    >
                        <div className="w-16 h-16 bg-blue-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-500 transition-colors duration-300">
                            <GraduationCap size={32} className="text-blue-600 group-hover:text-white transition-colors duration-300" />
                        </div>
                        <h2 className="text-xl font-bold text-slate-900 mb-2">Campus Virtual</h2>
                        <p className="text-slate-500">Acceda a sus cursos, certificaciones y material de estudio.</p>
                    </button>

                    {/* Subscription Card */}
                    <button 
                        onClick={() => navigate('/suscripcion')}
                        className="group bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-slate-100 hover:border-emerald-500 text-left"
                    >
                        <div className="w-16 h-16 bg-emerald-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-emerald-500 transition-colors duration-300">
                            <CreditCard size={32} className="text-emerald-600 group-hover:text-white transition-colors duration-300" />
                        </div>
                        <h2 className="text-xl font-bold text-slate-900 mb-2">Gestión de Suscripción</h2>
                        <p className="text-slate-500">Administre su plan, facturación y usuarios.</p>
                    </button>
                </div>

                <div className="mt-12 text-center">
                    <button 
                        onClick={handleLogout}
                        className="text-slate-400 hover:text-slate-600 flex items-center gap-2 mx-auto transition-colors"
                    >
                        <LogOut size={18} />
                        <span>Cerrar Sesión</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PortalSelection;
